import { createFSMReducer } from 'app-webtech-core/reducers/fsm';
import { FETCH_ALL, FETCH_BY_SLUG, FETCH_SERIES_SEASONS } from '../actions/types';
import {
  vodContentFetchAllFailureReducer,
  vodContentFetchAllRequestReducer,
  vodContentFetchAllSuccessReducer,
} from './fetchAll';
import {
  vodContentFetchBySlugRequestReducer,
  vodContentFetchBySlugSuccessReducer,
  vodContentFetchBySlugFailureReducer,
} from './fetchBySlug';
import {
  vodContentFetchSeriesSeasonsSuccessReducer,
  vodContentFetchSeriesSeasonsFailureReducer,
} from './fetchSeriesSeasons';
import { VOD_CONTENT_STATE_STATUSES } from '../constants';

export const defaultState = {
  params: null,
  result: [],
  entities: {},
  status: VOD_CONTENT_STATE_STATUSES.EMPTY,
  currentItemDetailId: null,
  error: null,
};

const params = {
  initial: VOD_CONTENT_STATE_STATUSES.EMPTY,
  actionReducers: {
    [FETCH_ALL.REQUEST]: {
      reducer: vodContentFetchAllRequestReducer,
    },
    [FETCH_ALL.SUCCESS]: {
      reducer: vodContentFetchAllSuccessReducer,
      next: VOD_CONTENT_STATE_STATUSES.DONE,
    },
    [FETCH_ALL.FAILURE]: {
      reducer: vodContentFetchAllFailureReducer,
      next: VOD_CONTENT_STATE_STATUSES.ERROR,
    },
    [FETCH_BY_SLUG.REQUEST]: {
      reducer: vodContentFetchBySlugRequestReducer,
    },
    [FETCH_BY_SLUG.SUCCESS]: {
      reducer: vodContentFetchBySlugSuccessReducer,
    },
    [FETCH_BY_SLUG.FAILURE]: {
      reducer: vodContentFetchBySlugFailureReducer,
    },
    [FETCH_SERIES_SEASONS.SUCCESS]: {
      reducer: vodContentFetchSeriesSeasonsSuccessReducer,
    },
    [FETCH_SERIES_SEASONS.FAILURE]: {
      reducer: vodContentFetchSeriesSeasonsFailureReducer,
    },
  },
  states: {
    [VOD_CONTENT_STATE_STATUSES.EMPTY]: {
      accepts: '*',
    },
    [VOD_CONTENT_STATE_STATUSES.PENDING]: {
      accepts: '*',
    },
    [VOD_CONTENT_STATE_STATUSES.DONE]: {
      accepts: '*',
    },
    [VOD_CONTENT_STATE_STATUSES.ERROR]: {
      accepts: '*',
    },
  },
};

export const vodContentReducer = createFSMReducer(defaultState, params);
